import CryptoJS from 'crypto-js'
import { BlockNoteEditor } from "@blocknote/core";
import { BlockNoteView, useBlockNote } from "@blocknote/react";
import "@blocknote/react/style.css";
import {convertEditorFormat, convertEditorJsToHtml} from "./ConvertToNewFormat";
import { useParams } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import '../css/BlockNote.css'
import { Breadcrumbs, Card } from "@mui/material";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFaceSmile, faShareFromSquare } from '@fortawesome/free-regular-svg-icons'
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';

import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import DialogContent from '@mui/material/DialogContent';
import Menu from '@mui/material/Menu';

import { useNavigate } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DialogContentText from '@mui/material/DialogContentText';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';

import LZString from "lz-string";
import * as Y from "yjs";
import { WebsocketProvider } from "y-websocket";
import { faGear } from '@fortawesome/free-solid-svg-icons';

function makeid(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}
function getColor(){ 
  
  const colors = ['#FF5733', '#33FF57', '#3366FF', '#FF33E9', '#33FFE6', '#FF5733', '#33FF57', '#3366FF', '#FF33E9', '#33FFE6'];

  // Generate a random index within the length of the colors array
  const randomIndex = Math.floor(Math.random() * colors.length);

  // Return the color at the randomly generated index
  return colors[randomIndex];
}
function hslToHex(h, s, l) {
  l /= 100;
  const a = s * Math.min(l, 1 - l) / 100;
  const f = n => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color).toString(16).padStart(2, '0');   // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}
const handleCompress = (text) => {
  const compressed = LZString.compressToBase64(text);
  return compressed;
};

const handleDecompress = (text) => {
  const decompressed = LZString.decompressFromBase64(text);
return decompressed
};

const decrypt = (text, privateKey, public_key) => {
  const decrypted = CryptoJS.AES.decrypt(text, CryptoJS.enc.Hex.parse(privateKey), {
    iv: CryptoJS.enc.Hex.parse(public_key),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);

  return decrypted;
};
export default function BlockNote({
  clientId,
  sessionId,
  encrypt,
  username,
  colorScheme,
  noteId,
  updateTab,
  findNameById,
  globalNotes,
  findNotePath,
  globalEditors,
  globalNoteContent,
  value,
  privateKey,
  publicKey,
  wsClose,
  ws,
  initialized,
  setWsClose,
  setInitialized,
  socket,
  room,
  sendMessage,
}) {
  const navigate = useNavigate()
  const doc = new Y.Doc();
  const randomColor = getColor();

  let provider = new WebsocketProvider('wss://donotes-server.com:1111', room, doc);
  const [editorNames, setEditorNames] = useState([])
  const [openSettings, setOpenSettings] = useState(false)
  const [saveStatus, setSaveStatus] = useState(false)
  const [notePath, setNotePath] = useState([])
  const [noteName, setNoteName] = useState()
  const [openShareFile, setOpenShareFile] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [initialContent, setInitialContent] = useState(null);
  const [shareBtn, setShareBtn] = useState('Generate share link')
  const [editorContent, setEditorContent] = useState(null)
  const [bgLoad, setBgLoad] = useState(false);
  const [connectionAttempt, setConnectionAttemp] = useState(0)
  const shareInput = useRef()
  useEffect(()=>{
    
    return () => {
      provider.destroy()
    }
  },[room])
  useEffect(()=>{
    if(globalEditors.ids) {
      if(globalEditors.ids.length > 0) {
    setEditorNames(globalEditors.uns)

      }
    }
  }, [globalEditors])
  const handleClickOpenShareFolder = () => {
    setShareBtn('Generate share link')
    setOpenShareFile(true);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handlecloseShareFile = () => {
    setOpenShareFile(false);
  };
  function share() {

    handleClickOpenShareFolder()
  }
  function handleShare() {
    setBgLoad(true)
    setOpenShareFile(false)
    let shareName = shareInput.current.value
    const username = encrypt(shareName, privateKey, publicKey)
    const encNid = encrypt(noteId, privateKey, publicKey)
        const message = {
          type: 'share-note',
          clientId,
          sessionId,
          noteId,
          shareName: username,
        }
        sendMessage(message)

  }
  function unShare() {
    setBgLoad(true)
    setOpenShareFile(false)
        const message = {
          type: 'unshare-note',
          clientId,
          sessionId,
          noteId,
        }
        sendMessage(message)

  }
  const handleEnterKeyShare = (event) => {
    if (event.key === 'Enter') {
      event.stopPropagation()
      event.preventDefault()
      // Handle the Enter key press here
      handleShare()
      // You can add your logic here, for example, call a function or perform an action
    }
  };
  function handleChange(e, f) {
    
    const blocks = editor.topLevelBlocks;
  }

  let editor;
  function retrieveImageFromClipboardAsBlob(pasteEvent, callback){
    if(pasteEvent.clipboardData == false){
          if(typeof(callback) == "function"){
              callback(undefined);
          }
      };
  
      var items = pasteEvent.clipboardData.items;
  
      if(items == undefined){
          if(typeof(callback) == "function"){
              callback(undefined);
          }
      };
  
      for (var i = 0; i < items.length; i++) {
          // Skip content if not image
          if (items[i].type.indexOf("image") == -1) continue;
          pasteEvent.preventDefault();
          pasteEvent.stopPropagation()
          // Retrieve image on clipboard as blob
          console.log(items[i].getAsFile())
          var blob = items[i].getAsFile();

          if(typeof(callback) == "function"){
              callback(blob);
          }
      }
  }
  const uploadImage = async (base64Image) => {
    const apiUrl = "https://api.imgbb.com/1/upload";
    const apiKey = "f666d364fc86e48d3e9d0e07d0fd4b5a"; // Replace with your actual API key

    const formData = new FormData();
    formData.append("image", base64Image);

    try {
      const response = await fetch(`${apiUrl}?key=${apiKey}`, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();
      const img = result.data.display_url;
      
      const id = editor.getTextCursorPosition().block.id;
      editor.insertBlocks([{type: "image", props: {url: img,caption: "Pasted image"}}], id, "after")
    } catch (error) {
      console.error('Error uploading image:', error);
    }
  };
  useEffect(() => {
    const handlePaste = async (e) => {
      retrieveImageFromClipboardAsBlob(e, (imageBlob) => {
        if (imageBlob) {
          // Create an image to render the blob
          const img = new Image();
          
          // Once the image loads, log the image src to the console
          img.onload = function() {
            console.log(img.src);
            uploadImage(imageBlob)


          };

          // Crossbrowser support for URL
          const URLObj = window.URL || window.webkitURL;

          // Creates a DOMString containing a URL representing the object given in the parameter
          // namely the original Blob
          img.src = URLObj.createObjectURL(imageBlob);
        }
      });
    };

    // Add event listener for paste event
    window.addEventListener('paste', (handlePaste));

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('paste', handlePaste);
    };

  }, [editor]);
  
  useEffect(()=>{
    const name = findNameById(globalNotes, noteId)
    if(name === null) {
      navigate('/')
    } 
    setNoteName(name)
    setNotePath(findNotePath(noteId).slice().reverse())
    updateTab(value, name, `/editor/${noteId}`)
    if(editor) {
      editor.onEditorContentChange(()=>{
  
        try {
          const savedData = editor.topLevelBlocks
          const content = JSON.stringify(savedData);
          const encryptedContent = encrypt(content, privateKey, publicKey);
          const sendContent = handleCompress(encryptedContent);
          const message = {
            type: 'update-note',
            sessionId,
            clientId,
            content: sendContent,
          };
          sendMessage(message)
        }catch (error) {
          console.error(error)
        }
      })
    }
    return () => {
      provider.destroy()
    }
  }, [noteId, globalNotes, editor])
  useEffect(() => {
    async function loadNewData() {
  
       const oldContent = globalNoteContent;
      //const oldContent = '<h1>Hi</h1>'
      try {
        //Check JSON   
        const parsed = JSON.parse(oldContent);
        try {
          //Check if JSON Happy  
          const newContent = convertEditorFormat(parsed);
          editor.replaceBlocks(editor.topLevelBlocks, newContent)
          setInitialized(true)
        }catch(error) {
          //JSON not happy :( Trying to parse via HTML
          if(editor) {
            try {
              const lastAttempt = convertEditorJsToHtml(oldContent)
              const blocksFromHTML = await editor.tryParseHTMLToBlocks(lastAttempt);
              editor.replaceBlocks(editor.topLevelBlocks, blocksFromHTML)
              setInitialized(true)
            }catch(error) {
              //if even this doesn't work, then display note as ugly json
              const blocksFromHTML = await editor.tryParseHTMLToBlocks(oldContent);
              editor.replaceBlocks(editor.topLevelBlocks, blocksFromHTML)
              setInitialized(true)
            }
          }
        }
      }catch(error) {
        //Not JSON, so must be HTML
        if(editor) {
          try {
          const blocksFromHTML = await editor.tryParseHTMLToBlocks(oldContent);
          editor.replaceBlocks(editor.topLevelBlocks, blocksFromHTML)
          setInitialized(true)
          }
          catch(error) {
            console.error('Error inserting note... Ignore this if your note still loads anyway')
          }
        }
      }
    }
    loadNewData()
  }, [globalNoteContent, editor]);
  

  useEffect(()=>{
    if(noteName) {
      
    document.title = `${noteName} | DoNotes`
    }
  }, [noteName])
  function reconnect() {
    setConnectionAttemp(`${getColor}`)
  }
  async function uploadFile(file) {
    const body = new FormData();
    body.append('image', file);
  
    const response = await fetch('https://api.imgbb.com/1/upload?key=f666d364fc86e48d3e9d0e07d0fd4b5a', {
      method: 'POST',
      body: body,
    });
  
    const result = await response.json();
    return result.data.url.replace('tmpfiles.org/', 'tmpfiles.org/dl/');
  }
  editor = useBlockNote({
    
    collaboration: {
      provider,
      fragment: doc.getXmlFragment("document-store"),
      user: {
        name: username,
        color: `${randomColor}`,
      },
    },
    initialContent,
    uploadFile,
    onEditorContentChange: (editor) => {     
    },
  });
  useEffect(()=>{

  },[editorNames])
  function handleSave() {
    const id = makeid(5)
    setSaveStatus(id)
  }
  return (
  <>
  
  <div className="topbar">
  <Breadcrumbs aria-label="breadcrumb">
        {notePath.map((item, index) => (
        <span key={index} color="inherit">
          {item}
        </span>
      ))}
      <span>
        {noteName}
      </span>
      </Breadcrumbs>
      <div style={{
        marginLeft: 'auto',
      }}>
      
      <span onClick={handleClick} className='avatarClick'>
      <AvatarGroup max={4} >
        {editorNames && editorNames.length > 0 && editorNames.map((edit, index) => (
        <Avatar key={index} alt={edit}>
          {edit[0]}
        </Avatar>
      ))}
      </AvatarGroup>
        </span>
        
      </div>
      <div style={{
        display: 'flex',
        gap: 10,
      }}>
        
      <Tooltip title="Share note" placement='top' arrow >
        <md-filled-tonal-button onClick={handleClickOpenShareFolder}>
        <FontAwesomeIcon slot="icon" icon={faShareFromSquare} />
          Share
        </md-filled-tonal-button>
        </Tooltip>
        <Tooltip title="Settings" placement='top' arrow>
          <md-icon-button onClick={()=>setOpenSettings(true)}>
            <FontAwesomeIcon icon={faGear} style={{color: 'var(--md-sys-color-secondary)'}} />
          </md-icon-button>
        </Tooltip>
      </div>
  </div>
  <div 
  className="blocknote-container"
  style={{
    overflowY: 'auto',
    
  }}>
     {initialized && <BlockNoteView editor={editor} theme={colorScheme} />}
  </div>
      {/**Reconnect */}
      <Dialog
        open={wsClose}
        sx={{
          minWidth: 300,
        }}
        >
          <DialogContent sx={{minWidth: 300}}>
            <DialogContentText>
              <h1>Uh oh ⌚</h1>
              <h3>It appears you timed out</h3>
              <md-filled-button onClick={reconnect}>
                Click to reconnect
              </md-filled-button>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      {/**End reconnect */}
      
      {/**Settings */}
      <Dialog
        open={openSettings}
        sx={{
          minWidth: 300,
        }}
        onClose={()=>{setOpenSettings(false)}}
        >
          <DialogContent sx={{minWidth: 300}}>
            <DialogContentText>
              <h1>Settings</h1>
              <h2>Move note</h2>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      {/**End Settings */}
      {/**Share file */}
      <Dialog
        open={openShareFile}
        onClose={handlecloseShareFile}
        sx={{
          minWidth: 300
        }}
      >

        <DialogContent sx={{minWidth: 300}}>
          <DialogContentText>
            <span style={{fontSize: 20, paddingBottom: 51}}>Share {noteName}</span>
            <br />
          </DialogContentText>
          <div style={{display: 'flex', flexDirection: 'column', marginTop: 10}}>
          <md-filled-tonal-button onClick={()=>{}}>{shareBtn}</md-filled-tonal-button>
          <div style={{width :'100%', textAlign: 'center'}}>
            or
          </div>
          <label style={{marginBottom: 10}}>Share to user:</label>
          <md-outlined-text-field
            ref={shareInput}
            name="username"
            label="Username"
            type="text"
            ></md-outlined-text-field>
          </div>
        </DialogContent>
        <DialogActions>
          <div style={{
            display: 'inline-flex',
            flexDirection: 'column',
            width: '100%',
            alignItems: 'center',
            gap: 10,
          }}>
            {/**
             * 
          <div>
            
          <md-outlined-select required>
            <md-select-option value="readonly" selected>
              <div slot="headline">Read only</div>
            </md-select-option>
            <md-select-option value="edit">
              <div slot="headline">Edit</div>
            </md-select-option>
          </md-outlined-select>
          </div>
             */}
          <div style={{display: 'flex', gap: 10}}>
            
          <md-filled-button onClick={handleShare} >
            Share
          </md-filled-button>
          
          <md-outlined-button onClick={handlecloseShareFile}>
            Cancel
          </md-outlined-button>
          <hr />
          <md-filled-tonal-button onClick={unShare}>
            Remove collaborators
          </md-filled-tonal-button>
          </div>
            </div>
        </DialogActions>
        <div style={{padding: 10, textAlign: 'center'}}>
          
        </div>
      </Dialog>
      {/**End share file */}
      {/**Avatar expanded */}
      
      <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        ><List>
          
        {editorNames && editorNames.length > 0 && editorNames.map((edit, index) => (
        
        <ListItem
        /**
      
        secondaryAction={
          <IconButton edge="end" aria-label="delete">
            <DeleteIcon />
          </IconButton>
        } */
      >
        <ListItemAvatar>
        <Avatar key={index} alt={edit}>
          {edit[0]}
        </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={edit}
        />
      </ListItem>
      ))}
          
      </List>
        </Menu>
        {/**End avatar expand */}
  </>)
  ;
}
